<template>
    <div class="minisite-float-button">
        <template-00 v-if="data.style.templateId === '00'" :data="data"></template-00>
    </div>
</template>
<script>
    import bgMusicTemplate from './bgMusic'

    export default {
        name: "float-buttonComponent",
        props: {
            data: {}
        },
        components: {
            'template-00': bgMusicTemplate.Template00
        }
    }
</script>

<style lang="less" scoped>

    .minisite-float-button {
        width: 100%;
        height: 100%;
    }

</style>
